import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primeReact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import TextareaInput from "../../../../../../components/input/TextareaInput";
import { updateParcels } from "../../../../../../services/Parcel/updateParcel";
import { useParcelContext } from "./ParcelContext";

const ModalUpdateInstruction = () => {
  const {
    control,
    handleSubmit: handleUpdateInstruction,
    reset: resetUpdateInstruction,
    errors,
  } = useForm();

  const {
    idSale,
    itemsSelected,
    setItemsSelected,
    setSelectAll,
    isModalVisibleAlterDesc,
    setIsModalVisibleAlterDesc,
    setSelectedValue,
    refetch,
  } = useParcelContext();

  const style = {
    width: window.innerWidth <= 992 ? "95vw" : "95vw",
  };

  function sendInstruction(data) {
    const selectedParcelIds = itemsSelected.map(
      (selectedParcel) => selectedParcel.id
    );
    let obj = {
      action: "alter_desc",
      sale_id: idSale,
      installments: {},
    };
    obj.instruction_bank = data.instruction_bank;
    obj.instruction_client = data.instruction_client;
    selectedParcelIds.forEach((id, index) => {
      obj.installments[index] = {
        id: id,
      };
    });
    setIsModalVisibleAlterDesc(false);

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    // Executa a função de atualização das parcelas
    updateParcels(obj)
      .then(() => {
        // Em seguida, atualiza os itens selecionados e chama a função de refresh
        setItemsSelected([]);
        setSelectAll([]);
        resetUpdateInstruction();
        return refetch();
      })
      .then(() => {
        // Depois que o refresh for concluído com sucesso, atualize a notificação para indicar sucesso
        toast.update(notification, {
          render: "Instruções alteradas com sucesso!",
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      })
      .catch((error) => {
        toast.update(notification, {
          render: "Não foi possível alteras as instruções!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao alterar instruções:", error);
      });
  }
  return (
    <>
      <Dialog
        header="Alterar Instruções"
        id="modal_cad"
        className="rounded-4"
        onHide={() => setIsModalVisibleAlterDesc(!isModalVisibleAlterDesc)}
        visible={isModalVisibleAlterDesc}
        style={style}
      >
        <Divider align="left">
          <div className="inline-flex align-items-center">
            <i className="pi pi-user mr-2"></i>
            <b> Informações das parcelas</b>
          </div>
        </Divider>
        <form onSubmit={handleUpdateInstruction(sendInstruction)}>
          <div>
            <div className="mb-2 mt-4 mx-2" >
              <TextareaInput
                onChange={(e) => {
                  setSelectedValue((prevValue) => ({
                    ...prevValue,
                    instruction_client: e.target.value,
                  }));
                }}
                type="textarea"
                className={`w-50 p-inputtext-sm rounded-4`}
                label="Instrução Cliente (Sobrescreve o Padrão)"
                errors={errors}
                isRequired={true}
                control={control}
                name="instruction_client"
                rows={4}
                cols={30}
              />
            </div>
            <div className="mb-2 mt-4 mx-2" >
              <TextareaInput
                onChange={(e) => {
                  setSelectedValue((prevValue) => ({
                    ...prevValue,
                    instruction_bank: e.target.value,
                  }));
                }}
                type="textarea"
                className={`w-50 p-inputtext-sm rounded-4`}
                label="Instrução Banco"
                errors={errors}
                isRequired={true}
                control={control}
                name="instruction_bank"
                rows={4}
                cols={30}
              />
            </div>

            <div className="text-center">
              <Button
                rounded
                label="Alterar"
                icon="fa fa-plus"
                type="submit"
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default ModalUpdateInstruction;
